<template>
    <tr class="mail_item">
      <td :data-label="translate('support.mail_list.id')" class="w50">
        {{ mail.id }}
      </td>
      <td :data-label="translate('support.mail_list.mailbox')">
        {{ mail.mailbox }}
      </td>
      <td :data-label="translate('support.mail_list.message_id')">
        <p class="limit" :title="mail.message_id">
          {{ mail.message_id }}
        </p>
      </td>
      <td :data-label="translate('support.mail_list.from_email')">
        <p class="limit">
          {{ mail.from_email }}
        </p>
      </td>
      <td :data-label="translate('support.mail_list.subject')" class="w10per">
        {{ mail.subject }}
      </td>
      <td :data-label="translate('support.mail_list.received_at')" v-html="get_date_any_lines(mail.received_at, null, 2)"></td>
      <td :data-label="translate('support.mail_list.device_id')">
        {{ mail.device_id }}
      </td>
      <td :data-label="translate('support.mail_list.ticket_id')">
        <router-link :to="'/ticket/' + mail.ticket_id">
          {{ mail.ticket_id }}
        </router-link>
      </td>
      <td :data-label="translate('support.mail_list.status_title')">
        {{ mail.status_title }}
      </td>
      <td :data-label="translate('support.mail_list.processed_at')" v-html="get_date_any_lines(mail.processed_at, null, 2)"></td>
      <td :data-label="translate('support.mail_list.category')">
        {{ mail.category }}
      </td>
      <td :data-label="translate('support.mail_list.action')">
        {{ mail.action }}
      </td>
      <td :data-label="translate('support.mail_list.action_reason')">
        {{ mail.action_reason }}
      </td>
      <td :data-label="translate('support.mail_list.target_folder')">
        {{ mail.target_folder }}
      </td>
    </tr>
</template>
<script>


export default {
  name: 'MailListItem',
  props: ["mail"]
}
</script>

<style lang="scss" scoped>
.mail{
  &_item{
    &:hover{
      background-color: #eee;
    }
    .limit{
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 0;
      font-size: 10px;
    }
  }
  tr {
    background-color: white;
    &:hover {
      background-color: #f1f1f1;
    }


  }
}
</style>
